import { render } from "./SmartphoneDisclaimer.vue?vue&type=template&id=6dcb4409&scoped=true"
import script from "./SmartphoneDisclaimer.vue?vue&type=script&lang=js"
export * from "./SmartphoneDisclaimer.vue?vue&type=script&lang=js"

import "./SmartphoneDisclaimer.vue?vue&type=style&index=0&id=6dcb4409&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcb4409"]])

export default __exports__